import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { TenTwentyFourCollapseSectionContainer } from '../../shared/sectionable/styles';
import Title from './invest-components/title';
import Details from './invest-components/details';
import { scrollIfHashMatch } from '../../shared/navigation/utils';
import useFundStateStore from '../common/fund-state-hook';

const Container = styled(TenTwentyFourCollapseSectionContainer)`
  padding-bottom: 100px;
`;

const sectionName = 'invest';
export default function Invest({ fund, investorTypes }) {
  const set = useFundStateStore(state => state.set);

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
    set(state => {
      state.hasInvest = true;
    });
  }, {});

  return (
    <Container name={sectionName}>
      <Title {...fund.company} />
      <Details fund={fund} investorTypes={investorTypes} />
    </Container>
  );
}

Invest.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    company: PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      logoColor: PropTypes.string,
      logoPictureUrl: PropTypes.string,
      name: PropTypes.string.isRequired,
      summary: PropTypes.string,
    }).isRequired,
    activePartnership: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
    investUrl: PropTypes.string,
    fundPageUrl: PropTypes.string,
    members: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      role: PropTypes.string,
    })).isRequired,
    pdsFileUrl: PropTypes.string,
  }).isRequired,
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};
